module.exports = __webpack_public_path__ + "static/media/logoNew.b3909fe8.png";